import Request from './request';
var request = new Request();
export var del = request.delete.bind(request);
export var get = request.get.bind(request);
export var post = request.post.bind(request);
export var put = request.put.bind(request);
export var patch = request.patch.bind(request);
export default request;